import React from 'react';

import { Button, CircularProgress, Stack } from '@mui/material';
import PropTypes from 'prop-types';

const LoadingButton = ({
  isLoading = false,
  loadingText,
  spinnerSize = 18,
  disabled,
  children,
  startIcon,
  ...rest
}) => (
  <Button
    {...rest}
    disabled={Boolean(isLoading) || Boolean(disabled)}
    startIcon={isLoading ? null : startIcon}
  >
    {isLoading ? (
      <Stack direction='row' alignItems='center' gap={1}>
        <CircularProgress
          size={spinnerSize}
          thickness={5}
          sx={{ color: 'inherit' }}
        />
        {loadingText && <span>{loadingText}</span>}
      </Stack>
    ) : (
      children
    )}
  </Button>
);

LoadingButton.propTypes = {
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
  spinnerSize: PropTypes.number,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  startIcon: PropTypes.node,
};

export default LoadingButton;
